<template>
    <div>
        <template v-if="!haveSlot">
            <v-text-field-filled
                v-if="!btnMode"
                :hide-details="true"
                readonly
                :label="!accountableAccountString ? accountableAccountTitle : undefined"
                :outlined="outlined"
                :rounded="rounded"
                style="overflow-x: hidden"
                @click.stop="!disabled ? (dialog = true) : ''"
                :data-cy="cypressPrefixKey + 'accountableAccount'"
                @keypress.tab="dialog = false"
                :model-value="accountableAccountString"
                density="compact"
            />
            <!-- <v-input
                :class="
                    'v-input v-input--hide-details v-input--is-label-active v-input--is-dirty v-input--is-readonly v-input--dense theme--light v-text-field v-text-field--is-booted v-text-field--enclosed' +
                    filled
                        ? 'bg-background'
                        : 'bg-primary-foreground'
                "
                :disabled="disabled"
                :append-inner-icon="
                    showValidation ? (validated ? '$oss-circle-check' : '$oss-circle-uncheck') : ''
                "
                :error="!validated"
                @click.stop="!disabled ? (dialog = true) : ''"
                density="compact"
                :hide-details="hideDetails"
                :style="inputStyle_"
                @click:append-inner="onValidatedChanged()"
                v-else-if="!btnMode"
                outlined
            >
                <v-row no-gutters>
                    <v-col cols="12" class="d-flex align-center" style="white-space: nowrap">
                        <span v-if="accountableAccountString">{{ accountableAccountString }}</span>
                        <div
                            v-else-if="showLabel && inputLabel"
                            class="v-label v-label--active theme--light ml-6"
                        >
                            {{ inputLabel }}
                        </div>
                    </v-col>
                </v-row>
                <template v-if="suggestion && showSuggestion">
                    <v-chip color="primary" class="ml-2" size="x-small">
                        {{ Math.round(suggestion.percentage * 100) + "%" }}
                    </v-chip>
                    <v-chip
                        color="secondary"
                        v-if="suggestion.clientCount"
                        class="ml-2"
                        size="x-small"
                    >
                        {{ suggestion.clientCount + " fois" }}
                    </v-chip>
                </template>
            </v-input> -->
        </template>
        <!-- <oss-dialog
            v-model="dialog"
            :title="dialogTitle"
            max-width="700px"
            :validDisabled="!needValidation ? false : validDisabled"
            :hideValid="!needValidation"
            :previous-display="step !== 'default'"
            :actions="step === 'user' ? actions : null"
            :disableActionSlot="step !== 'user'"
            @valid="onValidation"
            @close="previous()"
            @previous="previous()"
        > -->
        <oss-dialog
            v-model="dialog"
            :title="dialogTitle"
            :validDisabled="!needValidation && !displayValidBtn ? false : validDisabled"
            :hideValid="!needValidation && !displayValidBtn"
            :previous-display="step !== 'default'"
            :validTitle="validText"
            @valid="onValidation"
            @close="onClose()"
            @previous="previous()"
            min-width="50vw"
        >
            <template v-slot:activator="{ props }" v-if="step !== 'user'">
                <slot
                    name="activator"
                    :props="props"
                    :accountableAccountName="accountableAccountString"
                />
            </template>
            <!-- <template v-slot:after>
                <v-btn
                    icon
                    v-if="toEditAccountableAccount && toEditAccountableAccount.id"
                    @click="deleteAccountableAccount()"
                >
                    <v-icon  size="small">$oss-trash</v-icon>
                </v-btn>
            </template> -->
            <v-window v-model="step">
                <v-window-item :value="'default'">
                    <v-row no-gutters class="align-center">
                        <v-col :cols="editAccountableAccount ? 11 : 12">
                            <AccountableAccountFilter
                                v-model:search="search"
                                v-model:thirdParty="tiersSearch"
                                v-model:vatType="vatTypeSearch"
                                v-model:vatOperation="vatOperationSearch"
                                v-model:transactionType="transactionTypeSearch"
                                v-model:lettering="showLettering"
                                v-model:publish="showPublished"
                                v-model:default="showDefault"
                                v-model:activeFilters="activeFilters"
                                @keypress-enter="selectAccountableAccount()"
                                :data-cy="cypressPrefixKey + 'accountableAccount-search'"
                            />
                        </v-col>
                        <v-col cols="1" v-if="editAccountableAccount" class="d-flex justify-center">
                            <v-btn
                                icon="$add"
                                variant="flat"
                                @click="newAccountableAccount"
                                size="small"
                            >
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row no-gutters class="mt-2" v-if="activateFreeTag && selectedCompany">
                        <v-col>
                            <FreeTag
                                :companyTags="allCompanyTags"
                                :company="selectedCompany"
                                :createIfMissing="true"
                                @onTagsChanged="onTagsChanged"
                            />
                        </v-col>
                    </v-row>
                    <v-list
                        lines="three"
                        subheader
                        v-if="suggestions && suggestions.length"
                        density="compact"
                        width="100%"
                    >
                        <v-list-subheader>Suggestions</v-list-subheader>
                        <template v-for="suggestion in suggestions" :key="suggestion.key">
                            <v-list-item
                                v-show="isShow(suggestion.accountableAccount)"
                                ripple
                                border
                                rounded="lg"
                                @click="toggleSuggestion(suggestion)"
                                :class="
                                    !$vuetify.display.mobile
                                        ? 'mb-2 oss-list-item'
                                        : 'mb-2 px-2 oss-list-item'
                                "
                            >
                                <v-list-item-title>
                                    {{ getSuggestionName(suggestion) }}
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                    <div>{{ suggestion.accountableAccount.description }}</div>
                                    <div>
                                        <v-chip color="green" size="x-small" variant="flat">
                                            <v-icon size="x-small" location="start"> $star </v-icon>
                                            {{
                                                Math.round(suggestion.percentage * 100) +
                                                "% , " +
                                                suggestion.count +
                                                " fois"
                                            }}
                                        </v-chip>
                                        <v-chip
                                            color="secondary"
                                            v-if="suggestion.clientCount"
                                            class="ml-2"
                                            size="x-small"
                                            variant="flat"
                                        >
                                            <v-icon size="x-small" location="start">$star</v-icon
                                            >{{
                                                "Utilisé pour ce client " +
                                                suggestion.clientCount +
                                                " fois"
                                            }}
                                        </v-chip>
                                    </div>
                                </v-list-item-subtitle>
                                <template #append>
                                    <v-icon
                                        v-if="selected.name != suggestion.accountableAccount.name"
                                        color="grey"
                                        size="small"
                                    >
                                        $oss-circle-uncheck
                                    </v-icon>
                                    <v-icon v-else size="small">$oss-circle-check</v-icon>
                                </template>
                            </v-list-item>
                            <!-- <v-divider :key="'ds_'+suggestion.accountableAccount.name" v-if="index+1 < suggestions.length"></v-divider> -->
                        </template>
                    </v-list>
                    <v-divider v-if="suggestions && suggestions.length" />
                    <v-list-subheader>{{ accountableAccountTitle }}</v-list-subheader>
                    <v-virtual-scroll
                        :items="filteredAccountableAccounts"
                        :item-height="66"
                        height="504"
                        width="100%"
                    >
                        <template v-slot="{ item }">
                            <v-hover>
                                <template v-slot:default="{ isHovering, props }">
                                    <!-- <v-list-item :key="item"> -->
                                    <v-list-item
                                        v-bind="props"
                                        :key="'a_' + item.name"
                                        ripple
                                        @click="
                                            displayCheckIcon ? toggleAccountableAccount(item) : null
                                        "
                                        :class="
                                            !$vuetify.display.mobile
                                                ? 'mb-2 oss-list-item'
                                                : 'mb-2 px-2 oss-list-item'
                                        "
                                        :data-cy="'accountableAccount-' + item.name"
                                        border
                                        rounded="xl"
                                        lines="two"
                                        @keypress.enter="
                                            displayCheckIcon ? toggleAccountableAccount(item) : null
                                        "
                                    >
                                        <template
                                            #prepend
                                            v-if="!item.isStandard || item.invoiceProduct"
                                        >
                                            <v-icon>$subdirectory_arrow_right</v-icon>
                                        </template>
                                        <v-list-item-title>
                                            {{ getDisplayName(item) }}
                                            <v-chip
                                                v-for="info in complementInfo(item)"
                                                :key="item.name + '-' + info"
                                                label
                                                class="ml-2"
                                                size="x-small"
                                                >{{ info }}</v-chip
                                            >
                                        </v-list-item-title>
                                        <v-list-item-subtitle
                                            v-if="isAccountingUser || item.invoiceProduct"
                                        >
                                            <span v-if="isAccountingUser">{{
                                                item.description
                                            }}</span>
                                        </v-list-item-subtitle>
                                        <template #append>
                                            <v-row no-gutters>
                                                <v-col
                                                    cols="6"
                                                    class="d-flex align-center justify-center px-1"
                                                    v-if="
                                                        !item.invoiceProduct &&
                                                        editAccountableAccount &&
                                                        isHovering
                                                    "
                                                >
                                                    <v-btn-icon
                                                        icon="$oss-edit"
                                                        @click.stop="
                                                            setEditAccountableAccount(item)
                                                        "
                                                        size="small"
                                                    />
                                                </v-col>
                                                <v-col
                                                    v-if="displayCheckIcon"
                                                    cols="6"
                                                    class="d-flex align-center justify-center px-1"
                                                >
                                                    <v-icon
                                                        v-if="!item.isSelected(selected)"
                                                        color="grey"
                                                        size="small"
                                                    >
                                                        $oss-circle-uncheck
                                                    </v-icon>
                                                    <v-icon v-else size="small">
                                                        $oss-circle-check
                                                    </v-icon>
                                                </v-col>
                                            </v-row>
                                        </template>
                                    </v-list-item>
                                </template>
                            </v-hover>
                        </template>
                    </v-virtual-scroll>
                </v-window-item>
                <v-window-item :value="'company'">
                    <CompaniesTable
                        v-if="step === 'company'"
                        v-model="thirdPartyCompany"
                        :show-generic-company="selectedAccountableAccount.name.startsWith('401')"
                        :show-customer-companies="
                            (!showExistingCompanies &&
                                selectedAccountableAccount.name.startsWith('411')) ||
                            selectedAccountableAccount.name.startsWith('491')
                        "
                        :show-supplier-companies="
                            !showExistingCompanies &&
                            selectedAccountableAccount.name.startsWith('401')
                        "
                        :show-existing-companies="showExistingCompanies"
                        :parent-company-id="companyId"
                        :wizard-mode="true"
                    />
                </v-window-item>
                <v-window-item :value="'user'">
                    <select-user
                        ref="selectUser"
                        class="px-1"
                        v-if="step === 'user'"
                        v-model="thirdPartyUser"
                        :companyId="companyId"
                        v-model:step="userStep"
                        @isValidUser="isValidUser = $event"
                    />
                </v-window-item>
                <v-window-item :value="'bankAccount'">
                    <select-bankAccount
                        v-if="step === 'bankAccount'"
                        :company-id="companyId"
                        v-model="thirdPartyBank"
                    />
                </v-window-item>
            </v-window>
        </oss-dialog>
        <AccountableAccountEdition
            v-model="editAccountDialog"
            :aaCharacterCount="accountableAccountTable.aaCharacterCount"
            :accountableAccount="accountableAccountEdition"
            :existingAccountableAccounts="accountableAccountTable.accountableAccounts"
            @validate="upsertAccountableAccount"
            v-if="editAccountDialog"
        />
    </div>
</template>

<script lang="ts">
import _ from "lodash";
import gql from "graphql-tag";
import { Apollo } from "@/decorators";
import { State2Way } from "@/decorators";

// import DELETE_SUB_ACCOUNTABLE_ACCOUNT from "../graphql/accountableAccount/DeleteSubAccountableAccount.gql";
import REVENUE_ACCOUNTABLE_ACCOUNTS_QUERY from "../graphql/accountableAccount/RevenueAccountableAccounts.gql"; //
import EXPENSE_ACCOUNTABLE_ACCOUNTS_SUGGESTIONS_QUERY from "../graphql/ExpenseAccountsFromReconciliation.gql";
import EXPENSE_ACCOUNTABLE_ACCOUNTS_SUGGESTIONS_FROM_TPC from "../graphql/ExpenseAccountsFromThirdPartyCompany.gql";
import REVENUE_ACCOUNTABLE_ACCOUNTS_SUGGESTIONS_QUERY from "../graphql/RevenueAccountsFromReconciliation.gql";
import ACCOUNTABLEACCOUNT_SUGESSTIONS_FROM_BT from "../graphql/accountableAccount/AccountableAccountSuggestionsFromBT.gql";
import { Watch } from "vue-facing-decorator";

import {
    filterAccountableAccounts,
    filterAccountableAccountsWithType,
    filterAccountableAccountsWithTypes,
    getAccountableAccount,
    isGeneralAccountableAccount,
} from "../../../backend/src/common/accountableAccount/accountableAccountServices";
import { DialogAction } from "../services/dialogAction";
import { getAccountableAccountTable, getUserDisplayName } from "../services/userServices";
import { uniqBy } from "lodash";

import CompaniesTable from "./admin/CompaniesTable.vue";
import SelectBankAccount from "./bank/BankAccountSelector.vue";
import FreeTag from "./tag/FreeTag.vue";
import { ComponentBase } from "./ComponentBase";
import AccountableAccountEdition from "./admin/AccountableAccountEdition.vue";

import { AANode } from "./admin/AccountableAccountNode";

import { User } from "../store/store";
import { checkInt } from "../services/mathServices";
import { Component, Emit, Ref, toNative } from "vue-facing-decorator";
import { Prop, Model } from "vue-facing-decorator";
import SelectUserComp, { SelectUser } from "./user/SelectUser.vue";
import { compact } from "@apollo/client/utilities";
import AccountableAccountFilter from "./admin/AccountableAccountFilter.vue";
import { getAccountableAccountComplementInfo } from "@/services/accountableAccountServices";

// const REGEX_VAT_RATE = {
//     "20": /[0-9]{4}20/g,
//     "10": /[0-9]{4}10/g,
//     "8.5": /[0-9]{5}8/g,
//     "5.5": /[0-9]{5}5/g,
//     "2.1": /[0-9]{5}2/g,
//     "0NO_VAT_TYPE": /[0-9]{4}00/g,
//     "0INTRACOM": /[0-9]{4}30/g,
//     "0EXPORT": /[0-9]{4}80/g,
//     "0REVERSE_CHARGE": /[0-9]{4}90/g,
// }

class AccountableAccount {
    invoiceProduct;
    name: string;
    constructor() {}

    isSelected(selected) {
        if (!selected) {
            return false;
        }
        if (selected.name !== this.name) {
            return false;
        }
        if (this.invoiceProduct && !selected.invoiceProduct) {
            return false;
        }
        if (!this.invoiceProduct && selected.invoiceProduct) {
            return false;
        }
        if (
            this.invoiceProduct &&
            selected.invoiceProduct &&
            this.invoiceProduct.id !== selected.invoiceProduct.id
        ) {
            return false;
        }
        return true;
    }

    get isStandard() {
        return isGeneralAccountableAccount(this.name);
    }

    get subAccountableAccountCanBeAdded() {
        if (!this.name) {
            return false;
        }
        if (!this.isStandard) {
            return false;
        }
        // if (this.name.length !== 6) {
        //     return false
        // }
        const authorizedAccounts = ["445700", "467000"];
        for (const aa of authorizedAccounts) {
            if (this.name.startsWith(aa)) {
                return true;
            }
        }
        const forbiddenAccounts = ["4457", "401", "411", "467", "512"];
        for (const aa of forbiddenAccounts) {
            if (this.name.startsWith(aa)) {
                return false;
            }
        }
        return true;
    }
}

@Component({
    components: {
        CompaniesTable,
        SelectUser: SelectUserComp,
        SelectBankAccount,
        FreeTag,
        AccountableAccountEdition,
        AccountableAccountFilter,
    },
    emits: [
        "dialogClosed",
        "select-accountableAccount",
        "select-thirdPartyAccountableAccount",
        "close",
        "validated",
        "focus-on-date-or-wording",
    ],
})
export class AccountableAccountVue extends ComponentBase {
    // @Prop({ default: null }) value: any;
    /**
     *   ACCOUNTABLE ACCOUNT TYPES:
     *   - ThirdParty                 -> type: ThirdParty (comptes 4XXXXX)
     *   - Purchase                  -> type: Purchase (comptes 6XXXXX) ou comptes 275XXX
     *   - FixedAssetsAndPurchase    -> type: FixedAssets ou Purchase (comptes 2XXXXX + 6XXXXX)
     *
     *   - Sales                     -> company sales accounts 70XXXX
     *   - SalesWithOtherIncomes     -> company sales accounts 70XXXX
     *   - AllSales                  -> comptes all 70XXXX
     *   -
     *   - WithoutInvoice            -> type Capital, FixedAssets, Financial, Purchase, Sales
     *   - Start with WithoutInvoice -> type Capital, FixedAssets, Financial, Purchase, Sales
     *   - SalesWithVatRate0         -> comptes 7XXX00
     *   - Selected -> comptes et sous comptes définient dans inAccountableAccountNames
     *   - SelectedTypes -> comptes et sous comptes des types définient dans inAccountableAccountTypes
     */

    // @Prop({ default: "" }) value: string;
    // @Prop({ default: "" }) valueLabel: string;
    @Prop({ default: "" }) companyId: string;
    @Prop({ default: "" }) thirdPartyCompanyId: string;
    @Prop({ default: null }) thirdParty: any;

    @Prop({ default: true }) showValidation: boolean;

    @Prop({ default: true }) displayCheckIcon: boolean;

    @Prop({ default: "" }) title: string;
    @Prop({ default: false }) showLabel: boolean;
    @Prop({ default: "" }) label: string;
    @Prop({ default: false }) showSuggestion: boolean;
    @Prop({ default: false }) hideDetails: boolean;

    @Prop({ default: false }) outlined: boolean;
    @Prop({ default: undefined }) rounded: string;

    @Prop({ default: false }) disabled: boolean;
    @Prop({ default: false }) needValidation: boolean;

    @Prop({ default: undefined }) inAccountableAccount;
    @Prop({ default: null }) inAccountableAccounts;
    @Prop({ default: null }) inAccountableAccountNames: string[];
    @Prop({ default: null }) inAccountableAccountTypes: string[];

    @Prop({ default: null }) invoiceProduct;

    @Prop({ default: null }) excludesAccountableAccount: string[];

    @Prop({ default: "" }) inAccountableAccountType: string;
    @Prop({ default: undefined }) accountableAccountReplacementRule: any;
    @Prop({ default: "" }) inSearch: string;
    // @Prop({ default: undefined }) vatType: VATType;

    // @Prop({ default: false }) validated: boolean;
    @Prop({ default: null }) reconciliationItem;
    @Prop({ default: null }) subItem: number;

    @Prop({ default: null }) document: any;
    @Prop({ default: null }) bankTransactionId: string;

    // @Prop({ default: null }) bankTransaction: BankTransaction;
    // @Prop({ default: "" }) itemId: string;

    @Prop({ default: null }) reconciliation;

    @Prop({ default: "" }) inputStyle: string;

    @Prop({ default: "" }) showDescription: string;
    @Prop({ default: true }) mandatory: boolean;

    @Prop({ default: false }) btnMode: boolean;
    @Prop({ default: false }) startOpenDialog: boolean;

    // @Prop({ default: false }) hideSubAccountableAccount: boolean

    @Prop({ default: false }) editAccountableAccount: boolean;

    @Prop({ default: false }) embeddedInput: boolean;
    @Prop({ default: undefined }) innerId: string;

    @Prop({ default: false }) defineThirdParty: boolean;

    @Prop({ default: false }) activateFreeTag;

    @Prop({ default: "" }) cypressPrefixKey: string;

    @Prop({ default: false }) addInvoiceProduct: boolean;

    @Prop() tabindex: number;

    @Prop({ default: false }) onAccountingLinesPage: boolean;

    @Prop({ default: false }) publishedAccounts: boolean;

    @Model() value;

    @State2Way("updateAccountableAccountTable", "accountableAccountTable")
    accountableAccountTable;

    isValidSubAccountableAccount: boolean = false;

    dialog_: boolean = false;

    get dialog() {
        return this.dialog_;
    }

    set dialog(value) {
        this.dialog_ = value;
        if (!this.dialog_) {
            this.emitdialogClosed();
        }
    }

    @Emit("dialogClosed")
    emitdialogClosed() {
        return;
    }

    editAccountDialog: boolean = false;

    search_ = "";

    get search() {
        if (this.search_) {
            return this.search_;
        }
        return this.inSearch;
    }

    set search(data) {
        this.search_ = data;
    }

    activeFilters = false;
    tiersSearch = "";
    vatTypeSearch = "";
    vatOperationSearch = "";
    transactionTypeSearch = "";
    showLettering = false;
    showPublished = false;
    showDefault = false;

    selectedAccountableAccount: any = null;

    all: boolean = false;
    step = "default";
    userStep = "selectUser";

    lockAccountableAccount = false;

    thirdPartyCompany_ = null;
    thirdPartyUser_ = null;
    thirdPartyBank_ = null;

    isValidUser = false;

    actions = {
        action: new DialogAction(),
    };

    set thirdPartyCompany(data) {
        this.thirdPartyCompany_ = data;
        this.thirdPartyUser_ = null;
        this.thirdPartyBank_ = null;
        this.step = "default";
        if (!this.needValidation) {
            this.step = "default";
            this.toggleAccountableAccount_(this.selectedAccountableAccount);
            this.dialog = false;
        }
    }

    get thirdPartyCompany() {
        return this.thirdPartyCompany_;
    }

    set thirdPartyUser(data) {
        this.thirdPartyUser_ = data;
        this.thirdPartyCompany_ = null;
        this.thirdPartyBank_ = null;
        this.step = "default";
        if (!this.needValidation) {
            this.step = "default";
            this.toggleAccountableAccount_(this.selectedAccountableAccount);
            this.dialog = false;
        }
    }

    get thirdPartyUser() {
        return this.thirdPartyUser_;
    }

    set thirdPartyBank(data) {
        this.thirdPartyBank_ = data;
        this.thirdPartyCompany_ = null;
        this.thirdPartyUser_ = null;
        this.step = "default";
        if (!this.needValidation) {
            this.step = "default";
            this.toggleAccountableAccount_(this.selectedAccountableAccount);
            this.dialog = false;
        }
    }

    get thirdPartyBank() {
        return this.thirdPartyBank_;
    }

    get activateTagguing() {
        return this.activateFreeTag;
    }

    get selectedCompany() {
        return this.$store.getters.getCompany(this.companyId);
    }

    get enableStock() {
        return this.addInvoiceProduct && this.selectedCompany?.profile?.stock;
    }

    get isBNC() {
        return this.selectedCompany?.incomeCategory === "BNC";
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get isAccountingUser() {
        return this.currentUser?.isAccountingUser;
    }

    get isAutonomousUser() {
        return this.currentUser?.isAutonomousUser;
    }

    get isIncomingOutgoingPayment() {
        if (
            this.selectedCompany &&
            this.selectedCompany.profile &&
            this.selectedCompany.profile.accountingType === "INCOMING_OUTGOING_PAYMENT"
        ) {
            return true;
        }
        return false;
    }

    get haveSlot() {
        return this.embeddedInput;
    }

    get inputStyle_() {
        return this.inputStyle
            ? this.inputStyle +
                  "overflow-x: hidden; border-radius: 12px; z-index: inherit; backgroud-color: #F5F5F5;"
            : "overflow-x: hidden; border-radius: 12px; z-index: inherit; backgroud-color: #F5F5F5;";
    }

    get mode() {
        if (this.isAccountingUser) {
            return "ACCOUNTING";
        }
        return this.selectedCompany?.solution;
    }

    get dialogTitle() {
        // if (this.step === "subAccountableAccount") {
        //     if (this.toEditAccountableAccount.id) {
        //         return "Edition d'un compte comptable"
        //     }
        //     return "Création d'un compte comptable"
        // }
        if (this.title) {
            return this.title;
        }
        return this.mode === "MANAGEMENT" ? "Etiquettes" : "Plan comptable";
    }

    get itemId() {
        if (this.document) return this.document.id;
        // if (this.bankTransaction) return this.bankTransaction.id;
        if (this.reconciliation) return "";
        return "";
    }

    get accountableAccount() {
        if (this.value && this.defineThirdParty && this.value.accountableAccount)
            return this.value.accountableAccount;
        if (this.value) {
            if (this.dbAccountableAccount) {
                return this.dbAccountableAccount;
            }
            return this.value;
        }
        if (this.selectedAccountableAccount) {
            return this.selectedAccountableAccount;
        }
        if (this.inAccountableAccount?.name) {
            if (this.dbAccountableAccount) {
                return this.dbAccountableAccount;
            }
            return this.inAccountableAccount;
        }
        if (this.reconciliationItem) {
            if (this.reconciliationItem.accountingLine)
                return this.reconciliationItem.accountingLine.accountableAccount;
            // if (this.subItem === 1) return this.reconciliationItem.accountableAccount1;
            // if (this.subItem === 2) return this.reconciliationItem.accountableAccount2;
            if (this.reconciliationItem.accountableAccount)
                return this.reconciliationItem.accountableAccount;
        }
        if (this.document) {
            if (this.document.data?.stockOperation) {
                return {
                    ...this.document.accountableAccount,
                    invoiceProduct: {
                        id: this.document.data?.stockOperation.stockProductId,
                    },
                };
            }
            return this.document.accountableAccount;
        }
        // if (this.bankTransaction) return this.bankTransaction.accountableAccount;
        if (this.reconciliation) {
            for (const item of this.reconciliation) {
                if (item.bt) {
                    if (item.accountableAccount) return item.accountableAccount;
                    // if (item.bt.accountableAccount) return item.bt.accountableAccount;
                }
                if (item.doc) {
                    if (item.thirdPartyAccountableAccount) return item.thirdPartyAccountableAccount;
                    if (item.doc.thirdPartyAccountableAccount)
                        return item.doc.thirdPartyAccountableAccount;
                }
            }
        }
        if (
            this.accountableAccountType &&
            this.accountableAccountType.startsWith("Sales") &&
            this.accountableAccounts.length
        ) {
            const salesAccounts = ["701", "702", "704", "705", "706", "707", "708", "7085"];
            const foundAA = this.accountableAccounts.find((aa) =>
                salesAccounts.find((sa) => aa.name.startsWith(sa)),
            );
            if (foundAA) {
                this.toggleAccountableAccount_(foundAA);
            }
            return foundAA;
        }
        return undefined;
    }

    get accountableAccountAuto() {
        if (this.reconciliationItem) return this.reconciliationItem.accountableAccountAuto;
        if (this.document && this.document.accountableAccountAuto)
            return this.document.accountableAccountAuto;
        return undefined;
    }

    get validText() {
        // if (this.step === 'subAccountableAccount') {
        //     return `${this.toEditAccountableAccount?.id ? 'Modifier' : 'Créer' } le sous compte`
        // }
        if (this.step === "user" && this.userStep === "createUser") {
            return "Créer un utilisateur";
        }
        return "Valider";
    }

    get accountableAccount_() {
        if (this.accountableAccount) return this.accountableAccount;
        if (this.accountableAccountAuto) {
            if (
                this.accountableAccountAuto.name?.startsWith("600000") ||
                this.accountableAccountAuto?.startsWith("700000")
            ) {
                if (this.accountableAccounts && this.accountableAccounts.length === 1) {
                    return this.accountableAccounts[0];
                }
                if (this.suggestions.length) {
                    return this.suggestions[0].accountableAccount;
                }
            }
            return this.accountableAccountAuto;
        }
        if (this.accountableAccounts && this.accountableAccounts.length === 1) {
            return this.accountableAccounts[0];
        }
        return null;
    }

    get suggestion() {
        const accountableAccount = this.accountableAccount_;
        if (accountableAccount) {
            for (const suggestion of this.suggestions) {
                if (suggestion.accountableAccount.name === accountableAccount.name)
                    return suggestion;
            }
        }
        return null;
    }

    get showExistingCompanies() {
        return !this.companyId;
    }

    getSuggestionName(item) {
        let name = this.getDisplayName(item.accountableAccount);
        if (item.user) {
            name += " - " + getUserDisplayName(item.user);
        }
        if (item.bankAccount) {
            name += " - " + item.bankAccount.name;
        }
        if (item.thirdPartyCompany) {
            name += " - " + (item.thirdPartyCompany.shortName || item.thirdPartyCompany.name);
        }
        return name;
    }

    getDisplayName(aa) {
        if (aa) {
            if (!this.isAccountingUser) {
                return aa.shortDescription || aa.description || aa.name;
            } else {
                // if (aa.displayName) {
                //     return aa.displayName
                // }
                if (aa.name) {
                    return aa.name;
                }
            }
        }
        return "XXXXXX";
    }

    get displayValidBtn() {
        return (
            this.step === "subAccountableAccount" ||
            (this.step === "user" && this.userStep === "createUser")
        );
    }

    get accountableAccountString() {
        const accountableAccount = this.accountableAccount_;
        if (accountableAccount && accountableAccount.name) {
            if (this.mode === "MANAGEMENT")
                return (
                    accountableAccount.shortDescription ||
                    accountableAccount.description ||
                    accountableAccount.name
                );

            if (!this.isAccountingUser)
                return (
                    accountableAccount.shortDescription ||
                    accountableAccount.description ||
                    accountableAccount.name
                );

            let value = this.getDisplayName(accountableAccount);
            if (this.thirdParty) {
                const thirdPartyName = getUserDisplayName(this.thirdParty) || this.thirdParty.name;
                value += " - " + thirdPartyName;
            } else if (this.showDescription && accountableAccount.description) {
                // value += " - " + (accountableAccount.shortDescription || accountableAccount.description)
                value += " - " + accountableAccount.description;
            }
            return value;
        }
        return "";
    }

    get accountableAccountName() {
        return this.accountableAccount_ ? this.accountableAccount_.name : "";
    }

    get selectedIndice() {
        if (this.selected?.name) {
            return this.accountableAccounts.findIndex((aa) => aa.name === this.selected.name);
        }
        return -1;
    }

    set selectedIndice(value) {
        if (value) {
            console.log(value);
        }
    }

    get selected() {
        return this.accountableAccount_ || { name: "" };
    }

    get accountableAccounts_() {
        if (this.inAccountableAccounts) {
            return this.inAccountableAccounts;
        }
        if (this.accountableAccountReplacementRule) {
            if (this.accountableAccountReplacementRule.where) {
                return this.queryAccountableAccounts;
            }
        }
        if (this.accountableAccountType === "ThirdParty") {
            return this.thirdPartyAccountableAccounts;
        }
        if (
            this.accountableAccountType === "Purchase" ||
            this.accountableAccountType === "PurchaseGeneric"
        ) {
            return this.expenseAccountableAccounts;
        }
        if (this.accountableAccountType === "IncomingOutgoing") {
            return this.incomingOutgoingAccountableAccounts;
        }
        if (this.accountableAccountType === "FixedAssetsAndPurchase") {
            return this.fixedAssetsAndExpenseAccountableAccounts;
        }
        if (this.accountableAccountType === "AllSales") {
            return this.allRevenueAccountableAccounts;
        }
        if (
            this.accountableAccountType === "Sales" ||
            this.accountableAccountType === "SalesWithOtherIncomes"
        ) {
            return this.revenueAccountableAccounts;
        }
        if (this.accountableAccountType === "SalesWithVatRate0") {
            return this.revenueAccountableAccountsVateRate0;
        }
        if (this.accountableAccountType.startsWith("WithoutInvoice")) {
            return this.withoutInvoiceAccountableAccounts;
        }
        if (this.accountableAccountType === "627000") {
            return this.commissionAccountableAccounts;
        }
        if (this.accountableAccountType === "627100") {
            return this.commissionAccountableAccounts;
        }
        if (this.accountableAccountType === "Selected") {
            return this.customAccountableAccounts;
        }
        if (this.accountableAccountType === "SelectedTypes") {
            return this.customTypesAccountableAccounts;
        }
        return [];
    }

    get accountableAccounts() {
        const accountableAccounts = [];
        for (const aa of this.accountableAccounts_) {
            accountableAccounts.push(Object.assign(new AccountableAccount(), aa, {}));
        }
        if (this.invoiceProducts?.length) {
            for (const invoiceProduct of this.invoiceProducts) {
                if (invoiceProduct.accountableAccount?.name) {
                    const aaIndex = accountableAccounts.findIndex(
                        (aa) => aa.name === invoiceProduct.accountableAccount.name,
                    );
                    if (aaIndex !== -1) {
                        const aa = Object.assign(
                            new AccountableAccount(),
                            {
                                id: invoiceProduct.accountableAccount.id,
                                name: invoiceProduct.accountableAccount.name,
                                description:
                                    invoiceProduct.reference + " - " + invoiceProduct.title,
                                invoiceProduct: invoiceProduct,
                            },
                            {},
                        );
                        accountableAccounts.splice(aaIndex + 1, 0, aa);
                    }
                }
            }
        }
        return accountableAccounts;
    }

    get filteredAccountableAccounts() {
        let accountableAccounts = [];
        if (this.excludesAccountableAccount?.length) {
            accountableAccounts = this.accountableAccounts.filter((acc) => {
                return (
                    !this.excludesAccountableAccount.includes(acc.name) &&
                    !this.excludesAccountableAccount.includes(acc.displayName)
                );
            });
        } else {
            accountableAccounts = this.accountableAccounts;
        }
        if (!this.isAccountingUser) {
            accountableAccounts = uniqBy(accountableAccounts, this.getDisplayName);
        }

        if (this.search || this.activeFilters) {
            const filteredAccountableAccounts = [];
            for (const aa of accountableAccounts) {
                if (this.isShow(aa)) {
                    filteredAccountableAccounts.push(aa);
                }
            }
            return filteredAccountableAccounts;
        }

        return accountableAccounts;
    }

    get accountableAccountTitle() {
        if (this.isAutonomousUser) {
            return "Type d'opération";
        }
        if (this.label) {
            return this.label;
        }
        return this.$t("accountableAccount." + this.accountableAccountType);
    }

    get inputLabel() {
        if (!this.showLabel) {
            return undefined;
        }
        if (this.accountableAccountString) {
            return undefined;
        }
        if (this.isAutonomousUser) {
            return "Type d'opération";
        }
        if (this.label) {
            return this.label;
        }
        return "Compte comptable";
    }

    // get validated() {
    //     if (!this.mandatory) return true;
    //     if (!this.accountableAccount) {
    //         return false;
    //     }
    //     return (
    //         !this.accountableAccount.name.startsWith("600000") &&
    //         !this.accountableAccount.name.startsWith("700000")
    //     );
    // }

    get thirdPartyAccountableAccounts() {
        return filterAccountableAccountsWithType(this.accountableAccountTable, "ThirdParty", [
            "455",
        ]);
    }

    get incomingOutgoingAccountableAccounts() {
        if (this.isIncomingOutgoingPayment && this.isBNC && this.isAutonomousUser) {
            const filterAAs = [
                "201000",
                "203000",
                "205000",
                "206000",
                "207000",
                "208000",
                "211000",
                "212000",
                "213000",
                "214000",
                "215000",
                "218000",
                "261000",
                "445510",
                "606100",
                "606300",
                "607000",
                "613200",
                "613500",
                "615000",
                "616000",
                "621100",
                "622000",
                "622700",
                "625000",
                "625100",
                "625700",
                "626000",
                "627000",
                "628000",
                "635000",
                "635110",
                "641000",
                "645000",
                "646000",
                "646400",
                "647000",
                "658000",
                "668000",
                "706000",
                "706100",
                "706200",
                "758000",
                "768000",
            ];
            return filterAccountableAccounts(this.accountableAccountTable, filterAAs, []);
        }
        return filterAccountableAccounts(
            this.accountableAccountTable,
            ["6", "20", "21", "26", "44", "70", "75", "76"],
            [],
        );
    }

    get expenseAccountableAccounts() {
        if (this.isIncomingOutgoingPayment && this.isBNC) {
            const filterAAs = [
                "606100",
                "606300",
                "607000",
                "613200",
                "613500",
                "615000",
                "616000",
                "621100",
                "622000",
                "622700",
                "625000",
                "625100",
                "625700",
                "626000",
                "627000",
                "628000",
                "635000",
                "635110",
                "641000",
                "645000",
                "646000",
                "646400",
                "647000",
                "658000",
                "668000",
                "681110",
                "681120",
            ];
            const accountableAccounts = filterAccountableAccounts(
                this.accountableAccountTable,
                filterAAs,
                [],
            );
            return accountableAccounts;
        }
        const accountableAccounts = filterAccountableAccountsWithType(
            this.accountableAccountTable,
            "Purchase",
            [],
        );
        return accountableAccounts;
    }

    get fixedAssetsAndExpenseAccountableAccounts() {
        return filterAccountableAccounts(
            this.accountableAccountTable,
            ["6", "20", "21", "23", "25", "26", "27", "488"],
            [],
        );
    }

    @Apollo({
        query() {
            return REVENUE_ACCOUNTABLE_ACCOUNTS_QUERY;
        },
        variables() {
            return {
                companyId: this.companyId,
                vatRate0: false,
                withOtherIncomes: true,
            };
        },
        // debounce: 500,
        skip() {
            return (
                !this.dialog ||
                (this.accountableAccountType !== "Sales" &&
                    this.accountableAccountType !== "SalesWithOtherIncomes") ||
                this.inAccountableAccounts
            );
        },
        specificResult({ data, loading, networkStatus }: any) {
            this.loadingDocument = loading;
            if (!loading) {
                if (data && data.companySalesAccounts && data.companySalesAccounts.salesAccounts) {
                    this.revenueAccountableAccounts = data.companySalesAccounts.salesAccounts;
                } else {
                    console.log("AccountableAccountVue data pb");
                    this.revenueAccountableAccounts.splice(
                        0,
                        this.revenueAccountableAccounts.length,
                    );
                }
            }
        },
    })
    revenueAccountableAccounts: Array<any> = [];

    get allRevenueAccountableAccounts() {
        const incluedRootAAs = [
            "701000",
            "702000",
            "704000",
            "705000",
            "706000",
            "707000",
            "708000",
        ];
        return filterAccountableAccounts(this.accountableAccountTable, incluedRootAAs, []);
    }

    @Apollo({
        query() {
            return REVENUE_ACCOUNTABLE_ACCOUNTS_QUERY;
        },
        variables() {
            return {
                companyId: this.companyId,
                vatRate0: true,
                vatType: this.vatType,
                withOtherIncomes: true,
            };
        },
        // debounce: 500,
        skip() {
            return (
                !this.dialog ||
                this.accountableAccountType !== "SalesWithVatRate0" ||
                this.inAccountableAccounts
            );
        },
        specificResult({ data, loading, networkStatus }: any) {
            this.loadingDocument = loading;
            if (!loading) {
                if (data && data.companySalesAccounts && data.companySalesAccounts.salesAccounts) {
                    this.revenueAccountableAccountsVateRate0 =
                        data.companySalesAccounts.salesAccounts;
                } else {
                    console.log("AccountableAccountVue data pb");
                    this.revenueAccountableAccountsVateRate0.splice(
                        0,
                        this.revenueAccountableAccountsVateRate0.length,
                    );
                }
            }
        },
    })
    revenueAccountableAccountsVateRate0: Array<any> = [];

    get withoutInvoiceAccountableAccounts() {
        const types =
            this.accountableAccountType === "WithoutInvoice"
                ? ["Capital", "FixedAssets", "Financial", "Purchase", "Sales"]
                : ["Capital", "FixedAssets", "Financial", "Purchase"];
        return filterAccountableAccountsWithTypes(this.accountableAccountTable, types, [
            "51",
            "59",
            "701",
            "702",
            "703",
            "704",
            "705",
            "706",
            "707",
            "708",
        ]);
    }

    complementInfo(item) {
        return getAccountableAccountComplementInfo(item, true);
    }

    get dbAccountableAccount() {
        const name = this.value?.name || this.inAccountableAccount?.name;
        if (name) {
            return getAccountableAccount(this.accountableAccountTable, name);
        }
        return "";
    }

    get commissionAccountableAccounts() {
        return filterAccountableAccounts(this.accountableAccountTable, ["627100"], []);
    }

    get queryAccountableAccounts() {
        if (this.accountableAccountTable && this.accountableAccountReplacementRule?.where) {
            return filterAccountableAccounts(
                this.accountableAccountTable,
                this.accountableAccountReplacementRule.where.includeRootAAs,
                this.accountableAccountReplacementRule.where.excludeRootAAs,
            );
        }
        return [];
    }

    get customAccountableAccounts() {
        if (this.inAccountableAccountNames?.length) {
            return filterAccountableAccounts(
                this.accountableAccountTable,
                this.inAccountableAccountNames,
                [],
            );
        }
        if (this.accountableAccountTable) {
            return this.accountableAccountTable.accountableAccounts;
        }
        return [];
    }

    get customTypesAccountableAccounts() {
        const accountableAccounts = filterAccountableAccountsWithTypes(
            this.accountableAccountTable,
            this.inAccountableAccountTypes,
            [],
        );
        return accountableAccounts;
    }

    beforeMount() {
        // console.log("AccountableAccountVue mounted");
        this.dialog = this.startOpenDialog;
    }

    get accountableAccountType() {
        if (this.accountableAccountReplacementRule) {
            if (this.accountableAccountReplacementRule.accountableAccountType) {
                return this.accountableAccountReplacementRule.accountableAccountType;
            }
        }
        if (this.inAccountableAccountType) return this.inAccountableAccountType;
        if (this.inAccountableAccount?.name) {
            if (this.inAccountableAccount.name.startsWith("6")) {
                return "Purchase";
            }
            if (this.inAccountableAccount.name.startsWith("7")) {
                return "Sales";
            }
        }
        if (this.reconciliation /* || this.bankTransaction */) {
            return "ThirdParty";
        }
        if (this.document) {
            if (this.document.type === "WITHOUT_INVOICE") {
                return "WithoutInvoice";
            }
            if (this.expense) {
                return this.isIncomingOutgoingPayment && this.isBNC
                    ? "IncomingOutgoing"
                    : "FixedAssetsAndPurchase";
            }
            if (this.document && !this.document.vatAmountSigned) {
                return "SalesWithVatRate0";
            }
            return "Sales";
        }
        return "ThirdParty";
    }

    get vatType() {
        if (this.reconciliation) {
            return undefined;
        }
        if (this.document) {
            if (this.document.type === "WITHOUT_INVOICE") {
                return undefined;
            }
            if (this.expense) {
                return undefined;
            }
            if (!this.document.vatAmountSigned) {
                return this.document.vatType;
            }
            return undefined;
        }
        return undefined;
    }

    get suggestionThirdPartyCompanyId() {
        if (this.thirdPartyCompanyId) {
            return this.thirdPartyCompanyId;
        }
        if (this.document?.thirdPartyCompany?.id) {
            return this.document.thirdPartyCompany.id;
        }
        return undefined;
    }

    get expense() {
        if (this.document) {
            if (
                this.document.type === "SALES_INVOICE" ||
                this.document.type === "SALES_INVOICE_AUTO" ||
                this.document.type === "ZTILL_RECEIPT"
            ) {
                return false;
            }
        }
        return true;
    }

    @Apollo({
        query() {
            return this.expense
                ? this.document
                    ? EXPENSE_ACCOUNTABLE_ACCOUNTS_SUGGESTIONS_QUERY
                    : EXPENSE_ACCOUNTABLE_ACCOUNTS_SUGGESTIONS_FROM_TPC
                : REVENUE_ACCOUNTABLE_ACCOUNTS_SUGGESTIONS_QUERY;
        },
        variables() {
            return {
                companyId: this.companyId,
                documentId: this.document ? this.document.id : undefined,
                thirdPartyCompanyId: this.suggestionThirdPartyCompanyId || undefined,
                generic: this.expense,
            };
        },
        skip() {
            return (
                !this.dialog ||
                this.bankTransactionId ||
                ((!this.document || !this.document.id) &&
                    (!this.suggestionThirdPartyCompanyId || !this.companyId))
            );
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data) {
                    const result =
                        data.expenseAccountsFromReconciliation ||
                        data.revenueAccountsFromReconciliation ||
                        data.expenseAccountsFromThirdPartyCompany;
                    if (result) {
                        // if (data.accountableAccount) {
                        //     for (let i = 0; i < this.reconciliationItems.length; i++) {
                        //         const reconciliationItem = this.reconciliationItems[i];
                        //         if (reconciliationItem.type === "Document" && !reconciliationItem.accountableAccountAuto) {
                        //             this.reconciliationItems[i].accountableAccountAuto = data.accountableAccount;
                        //         }
                        //     }
                        // }
                        if (result.suggestions?.length) {
                            this.defaultSuggestions = result.suggestions;
                            // if (!this.document.accountableAccountAuto) {
                            // this.document.accountableAccountAuto = data.accountableAccounts[0].accountableAccount;
                            // }
                        } else {
                            this.defaultSuggestions.splice(0, this.defaultSuggestions.length);
                        }
                    } else {
                        this.defaultSuggestions.splice(0, this.defaultSuggestions.length);
                    }
                }
            }
        },
    })
    defaultSuggestions: any = [];

    @Apollo({
        query() {
            return ACCOUNTABLEACCOUNT_SUGESSTIONS_FROM_BT;
        },
        variables() {
            return {
                bankTransactionId: this.bankTransactionId,
            };
        },
        skip() {
            return !this.dialog || !this.bankTransactionId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data) {
                    const result = data.accountableAccountSuggestionsFromBT;
                    if (result) {
                        // if (data.accountableAccount) {
                        //     for (let i = 0; i < this.reconciliationItems.length; i++) {
                        //         const reconciliationItem = this.reconciliationItems[i];
                        //         if (reconciliationItem.type === "Document" && !reconciliationItem.accountableAccountAuto) {
                        //             this.reconciliationItems[i].accountableAccountAuto = data.accountableAccount;
                        //         }
                        //     }
                        // }
                        if (result.suggestions?.length) {
                            this.btSuggestions = result.suggestions;
                            // if (!this.document.accountableAccountAuto) {
                            // this.document.accountableAccountAuto = data.accountableAccounts[0].accountableAccount;
                            // }
                        } else {
                            this.btSuggestions.splice(0, this.btSuggestions.length);
                        }
                    } else {
                        this.btSuggestions.splice(0, this.btSuggestions.length);
                    }
                }
            }
        },
    })
    btSuggestions: any = [];

    get suggestions() {
        if (this.bankTransactionId) {
            return this.btSuggestions;
        }
        return this.defaultSuggestions;
    }

    isShow(item: any) {
        const nameMatch = item.name.toLowerCase().includes(this.search);
        const descMatch = item.description.toLowerCase().includes(this.search.toLowerCase());
        const transactionMatch = this.transactionTypeSearch
            ? item.transactionType === this.transactionTypeSearch
            : true;
        const vatTypeMatch = this.vatTypeSearch ? item.vatType === this.vatTypeSearch : true;
        const vatOpMatch = this.vatOperationSearch
            ? item.vatOperationType === this.vatOperationSearch
            : true;
        const tiersMatch = this.tiersSearch ? Boolean(item[this.tiersSearch]) : true;
        const publishMatch = this.showPublished ? Boolean(item.publish) : true;
        const letterinMatch = this.showLettering ? Boolean(item.lettering) : true;
        const defaultMatch = this.showDefault ? Boolean(item.default) : true;
        return (
            (nameMatch || descMatch) &&
            tiersMatch &&
            vatOpMatch &&
            vatTypeMatch &&
            transactionMatch &&
            publishMatch &&
            letterinMatch &&
            defaultMatch
        );
    }

    get validDisabled() {
        if (this.step === "subAccountableAccount") {
            return !this.isValidSubAccountableAccount;
        }
        if (this.step === "user" && this.userStep === "createUser") {
            return !this.isValidUser;
        }
        if (!this.selectedAccountableAccount) return true;

        const tpType = this.needsThirdParty(this.selectedAccountableAccount);
        if (tpType && this.defineThirdParty) {
            if (tpType === "company" && !this.thirdPartyCompany_) {
                return true;
            } else if (tpType === "user" && !this.thirdPartyUser_) {
                return true;
            } else if (tpType === "bankAccount" && !this.thirdPartyBank_) {
                return true;
            }
        }
        return false;
    }

    onValidatedChanged() {
        const accountableAccount = this.accountableAccount_;
        if (accountableAccount) {
            this.toggleAccountableAccount_(accountableAccount);
        }
    }

    toggleSuggestion(suggestion) {
        this.toggleAccountableAccount(suggestion.accountableAccount);
        if (suggestion.thirdPartyCompany) {
            this.thirdPartyCompany = suggestion.thirdPartyCompany;
        } else if (suggestion.user) {
            this.thirdPartyUser = suggestion.user;
        } else if (suggestion.bankAccount) {
            this.thirdPartyBank_ = suggestion.bankAccount;
        }
    }

    toggleAccountableAccount(accountableAccount) {
        const previousAAName = this.accountableAccountName;
        const previousInvoiceProduct = this.accountableAccount_?.invoiceProduct;
        this.selectedAccountableAccount = accountableAccount;
        const tpType = this.needsThirdParty(accountableAccount);
        if (tpType && this.defineThirdParty) {
            if (tpType === "company") {
                this.thirdPartyUser_ = null;
                this.thirdPartyBank_ = null;
            } else if (tpType === "user") {
                this.thirdPartyCompany_ = null;
                this.thirdPartyBank_ = null;
            } else if (tpType === "bankAccount") {
                this.thirdPartyUser_ = null;
                this.thirdPartyCompany_ = null;
            }
        } else {
            this.thirdPartyUser_ = null;
            this.thirdPartyCompany_ = null;
            this.thirdPartyBank_ = null;
        }
        if (!this.needValidation) {
            if (tpType && this.defineThirdParty) {
                this.step = tpType;
            } else {
                if (
                    previousAAName !== accountableAccount.name ||
                    (!previousInvoiceProduct && accountableAccount.invoiceProduct.id) ||
                    (previousInvoiceProduct?.id && !accountableAccount.invoiceProduct) ||
                    (previousInvoiceProduct &&
                        accountableAccount.invoiceProduct &&
                        previousInvoiceProduct.id !== accountableAccount.invoiceProduct.id)
                ) {
                    this.toggleAccountableAccount_(accountableAccount);
                }
                this.dialog = false;
            }
        } else {
            if (this.needsThirdParty(accountableAccount)) {
                this.step = this.needsThirdParty(accountableAccount);
            }
        }
        // this.search = ""
    }

    async onValidation() {
        if (this.step === "subAccountableAccount") {
            // await this.upsertAccountableAccount()
            return;
        }
        if (this.step === "user" && this.userStep === "createUser") {
            await this.createUser();
            return;
        }
        if (this.step === "user") {
            if (this.actions?.action?.function) {
                this.actions.action.function();
            }
        } else {
            this.dialog = false;
            if (!this.defineThirdParty) {
                this.emitValidated(this.selectedAccountableAccount);
            } else {
                const thirdParty = this.getThirdParty();
                this.emitValidated({
                    accountableAccount: this.selectedAccountableAccount,
                    thirdParty: thirdParty ? thirdParty : undefined,
                    tags: this.tags,
                });
            }
        }
    }

    @Emit("validated")
    emitValidated(data) {
        return data;
    }

    needsThirdParty(accountableAccount) {
        if (!accountableAccount) return "";
        if (accountableAccount.user) {
            return "user";
        } else if (accountableAccount.bankAccount) {
            return "bankAccount";
        } else if (accountableAccount.thirdPartyCompany) {
            return "company";
        }
        return "";
        // return accountableAccount.user || accountableAccount.bankAccount || accountableAccount.thirdPartyCompany\
        // if (accountableAccount.startsWith('401') ||
        //     accountableAccount.startsWith('411') ||
        //     accountableAccount.startsWith('491')
        // ) { // ACCOUNTABLE ACCOUNT WITH COMPANY
        //     return "company"

        // } else if (accountableAccount.startsWith('421') ||
        //     accountableAccount.startsWith('455') ||
        //     accountableAccount.startsWith('108') ||
        //     accountableAccount.startsWith('467')
        // ) { // ACCOUNTABLE ACCOUNT WITH USER
        //     return "user"

        // } else if (accountableAccount.startsWith('512')) {
        //     // ACCOUNTABLE ACCOUNT WITH BANK
        //     return "bankAccount"

        // }
    }

    getThirdParty() {
        let thirdParty = null;
        if (this.thirdPartyCompany) {
            thirdParty = {
                ...this.thirdPartyCompany,
                type: "company",
            };
        } else if (this.thirdPartyUser) {
            thirdParty = {
                ...this.thirdPartyUser,
                type: "user",
            };
        } else if (this.thirdPartyBank) {
            thirdParty = {
                ...this.thirdPartyBank,
                type: "bankAccount",
            };
        }
        return thirdParty;
    }

    toggleAccountableAccount_(accountableAccount) {
        if (!this.defineThirdParty) {
            this.emitSelectAccountableAccount({
                itemId: this.itemId,
                accountableAccount: accountableAccount,
                tags: this.tags,
            });
            this.value = accountableAccount;
        } else {
            if (this.reconciliationItem) {
                this.emitSelectThirdPartyAccountableAccount({
                    item: this.reconciliationItem,
                    thirdPartyAccountableAccount: accountableAccount,
                    tags: this.tags,
                });
            } else {
                const thirdParty = this.getThirdParty();

                this.emitSelectAccountableAccount({
                    itemId: this.itemId,
                    accountableAccount: accountableAccount,
                    thirdParty: thirdParty ? thirdParty : undefined,
                    tags: this.tags,
                });
                this.value = {
                    itemId: this.itemId,
                    accountableAccount: accountableAccount,
                    thirdParty: thirdParty ? thirdParty : undefined,
                    tags: this.tags,
                };
            }
        }
    }

    @Emit("select-thirdPartyAccountableAccount")
    emitSelectThirdPartyAccountableAccount(data) {
        return data;
    }

    @Emit("select-accountableAccount")
    emitSelectAccountableAccount(data) {
        return data;
    }

    @Emit("close")
    onClose() {
        this.dialog = false;
        this.step = "default";
        if (this.onAccountingLinesPage) {
            this.emitFocusOnDateOrWording();
        }
    }

    @Emit("focus-on-date-or-wording")
    emitFocusOnDateOrWording() {
        return;
    }

    async upsertAccountableAccount(aaData, propagation: boolean = false) {
        // this.toEditAccountableAccount = aaData
        if (aaData) {
            if (aaData.id) {
                await this.$apollo.mutate({
                    mutation: gql`
                        mutation (
                            $id: ID!
                            $description: String!
                            $shortDescription: String
                            $lettering: Boolean
                            $detailedCarryForward: Boolean
                            $vatRate: Float
                            $vatType: VATType
                            $vatOperationType: VATOperationType
                            $user: Boolean
                            $bankAccount: Boolean
                            $thirdPartyCompany: Boolean
                            $transactionType: BankTransactionTransactionType
                            $default: Boolean
                            $publish: Boolean
                        ) {
                            renameSubAccountableAccount(
                                data: {
                                    id: $id
                                    description: $description
                                    shortDescription: $shortDescription
                                    lettering: $lettering
                                    detailedCarryForward: $detailedCarryForward
                                    vatRate: $vatRate
                                    vatType: $vatType
                                    vatOperationType: $vatOperationType
                                    user: $user
                                    bankAccount: $bankAccount
                                    thirdPartyCompany: $thirdPartyCompany
                                    transactionType: $transactionType
                                    default: $default
                                    publish: $publish
                                }
                            ) {
                                id
                            }
                        }
                    `,
                    variables: {
                        id: aaData.id,
                        description: aaData.description,
                        shortDescription: aaData.shortDescription,
                        lettering: aaData.lettering,
                        detailedCarryForward: aaData.detailedCarryForward,
                        vatRate: aaData.vatRate,
                        vatType: aaData.vatType,
                        vatOperationType: aaData.vatOperationType,
                        user: aaData.user,
                        bankAccount: aaData.bankAccount,
                        thirdPartyCompany: aaData.thirdPartyCompany,
                        transactionType: aaData.transactionType,
                        default: aaData.default,
                        publish: aaData.publish,
                    },
                });
            } else {
                const subAccountableAccount = await this.$apollo.query({
                    query: gql`
                        query (
                            $accountableAccountTableId: ID!
                            $name: String!
                            $type: AccountableAccountType!
                            $description: String!
                            $lettering: Boolean!
                            $detailedCarryForward: Boolean!
                            $vatRate: Float
                            $vatType: VATType
                            $vatOperationType: VATOperationType
                            $user: Boolean!
                            $bankAccount: Boolean!
                            $thirdPartyCompany: Boolean!
                            $transactionType: BankTransactionTransactionType
                            $default: Boolean
                        ) {
                            getCreateAccountableAccount(
                                data: {
                                    accountableAccountTableId: $accountableAccountTableId
                                    name: $name
                                    type: $type
                                    description: $description
                                    lettering: $lettering
                                    detailedCarryForward: $detailedCarryForward
                                    vatRate: $vatRate
                                    vatType: $vatType
                                    vatOperationType: $vatOperationType
                                    user: $user
                                    bankAccount: $bankAccount
                                    thirdPartyCompany: $thirdPartyCompany
                                    transactionType: $transactionType
                                    default: $default
                                }
                            ) {
                                id
                                name
                                description
                                lettering
                                detailedCarryForward
                                vatRate
                                vatType
                                user
                                bankAccount
                                thirdPartyCompany
                                transactionType
                                default
                            }
                        }
                    `,
                    variables: {
                        accountableAccountTableId: this.accountableAccountTable.id,
                        ...aaData,
                    },
                });
                this.toggleAccountableAccount(
                    subAccountableAccount.data.getCreateAccountableAccount,
                );
            }
            // this.toEditAccountableAccount = _.cloneDeep(this.defaultAccountableAccount)
            this.step = "default";
            this.refreshQueries();
        }
    }

    // convertVatValues(vatRate) {
    //     switch (vatRate) {
    //         case "20": return { vatRate: 20, vatType: null }
    //         case "10": return { vatRate: 10, vatType: null }
    //         case "8.5": return { vatRate: 8.5, vatType: null }
    //         case "5.5": return { vatRate: 5.5, vatType: null }
    //         case "2.1": return { vatRate: 2.1, vatType: null }
    //         case "0NO_VAT_TYPE": return { vatRate: 0, vatType: "NO_VAT_TYPE" }
    //         case "0INTRACOM": return { vatRate: 0, vatType: "INTRACOM" }
    //         case "0EXPORT": return { vatRate: 0, vatType: "EXPORT" }
    //         case "0IMPORT": return { vatRate: 0, vatType: "IMPORT" }
    //         case "0REVERSE_CHARGE": return { vatRate: 0, vatType: "REVERSE_CHARGE" }
    //     }
    // }

    accountableAccountEdition: AANode = null;

    setEditAccountableAccount(accountableAccount) {
        if (!accountableAccount) {
            debugger;
            return;
        }
        this.lockAccountableAccount = true;
        // this.toEditAccountableAccount = accountableAccount
        this.accountableAccountEdition = new AANode(
            accountableAccount.name,
            accountableAccount.id,
            accountableAccount.description,
            accountableAccount.shortDescription,
            false,
            accountableAccount.lettering,
            accountableAccount.detailedCarryForward,
            accountableAccount.vatRate,
            accountableAccount.vatType,
            accountableAccount.vatOperationType,
            accountableAccount.type,
            accountableAccount.user,
            accountableAccount.bankAccount,
            accountableAccount.thirdPartyCompany,
            accountableAccount.transactionType,
            accountableAccount.default,
            accountableAccount.paidAndUncashed,
            accountableAccount.publish,
        );
        this.editAccountDialog = true;
    }

    newAccountableAccount() {
        this.lockAccountableAccount = true;
        // this.toEditAccountableAccount = null
        let name = "";
        let description = "";
        if (this.search) {
            if (checkInt(this.search)) {
                name = this.search;
            } else {
                description = this.search;
            }
        }
        this.accountableAccountEdition = new AANode(
            name,
            "",
            description,
            "",
            false,
            false,
            false,
            null,
            null,
            null,
            "",
            false,
            false,
            false,
            null,
            null,
            null,
            false,
        );
        this.editAccountDialog = true;
    }

    isAlreadyFocused = false;

    openDialog(accountableAccount) {
        if (accountableAccount) {
            this.search = accountableAccount.name;
            this.toggleAccountableAccount(accountableAccount);
        }
        this.dialog = true;
        //console.log("AccountableAccountVue openDialog", event);
    }

    previous() {
        // this.parentAccountableAccount = null
        // this.toEditAccountableAccount = _.cloneDeep(this.defaultAccountableAccount)
        // this.accountbleAccountDescription = ""
        this.lockAccountableAccount = false;
        this.step = "default";
        this.userStep = "selectUser";
    }

    selectAccountableAccount() {
        if (this.filteredAccountableAccounts.length === 1) {
            this.toggleAccountableAccount(this.filteredAccountableAccounts[0]);
        }
    }

    // async deleteAccountableAccount() {
    //     await this.$apollo.mutate({
    //         mutation: DELETE_SUB_ACCOUNTABLE_ACCOUNT,
    //         variables: {
    //             id: this.toEditAccountableAccount.id
    //         }
    //     })
    //     // TO FINISH
    //     // this.toggleAccountableAccount(this.editingAccountableAccount.subAccountableAccountOf)
    //     this.step = "default"
    //     this.refreshQueries()
    // }

    async refreshQueries() {
        const promises = [];
        for (const query in this.$apollo.queries) {
            promises.push(this.$apollo.queries[query].refresh());
        }
        await Promise.all(promises);
        await getAccountableAccountTable(this.$apollo, this.$store, {
            id: this.companyId,
        });
    }

    @Ref("selectUser") selectUser!: SelectUser;
    createUser() {
        this.selectUser.upsertUser(false);
    }

    //
    // tag management
    //

    tags = [];

    onTagsChanged(data) {
        this.tags = data.tags;
    }

    //
    // stock
    //
    @Apollo({
        query: gql`
            query InvoiceProducts(
                $companyId: ID!
                $accountableAccount: AccountableAccountWhereInput!
            ) {
                invoiceProducts(
                    where: {
                        company: { id: $companyId }
                        stock: true
                        accountableAccount: $accountableAccount
                        outDated_not: true
                    }
                ) {
                    id
                    reference
                    title
                    unitPrice
                    outDated
                    type
                    family
                    tag {
                        id
                        name
                    }
                    accountableAccount {
                        id
                        name
                    }
                    unitQuantity
                    data
                }
            }
        `,
        variables() {
            return {
                companyId: this.companyId,
                accountableAccount: { name1_in: ["6", "7"] },
            };
        },
        skip() {
            return !this.enableStock || !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (data) {
                this.invoiceProducts = data.invoiceProducts;
            } else {
                this.invoiceProducts = [];
            }
        },
    })
    invoiceProducts = [];

    get rules() {
        return {
            aaLength: (v) => {
                return (
                    (!!v && v.length === this.accountableAccountTable.aaCharacterCount) ||
                    "Nombre de caractères attendu= " + this.accountableAccountTable.aaCharacterCount
                );
            },
            checkExists: (value) => {
                return (
                    (value &&
                        !this.accountableAccountTable.accountableAccounts.find(
                            (aa) => aa.name === value,
                        )) ||
                    "Compte existant"
                );
                // return checkIBAN(value) || this.$t('settings.wrongIBAN')
            },
            isAA: (value) => {
                return (value && checkInt(value)) || "Mauvais format";
                // return checkIBAN(value) || this.$t('settings.wrongIBAN')
            },
        };
    }

    @Watch("dialog")
    onDialogChange(newVal: boolean) {
        if (!newVal) {
            this.emitFocusOnDateOrWording();
        }
        if (this.publishedAccounts) {
            this.activeFilters = true;
            this.showPublished = true;
        }
    }
}

export default toNative(AccountableAccountVue);
</script>

<style>
.error--text .v-text-field__slot > input {
    color: #ec6d56 !important;
}
</style>
